import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import InputField from '../../common/components/input-field'
import QuoteNumber from '../../common/components/quote-number'
import QueryString from 'query-string'
import Select from 'react-select'
import HighRiskItemsEditor from '../components/high-risk-items-editor'
import yesNoOptions from '../../common/options/yes-no-options'
import Alert from '../../common/components/alert'
import { Table, Row, Cell, Alternate } from '../../common/components/summary-table'
import { getQueryString } from '../../common/util'
import { withSubmission } from '../../common/modules/submission'
import { withForm } from '../../common/modules/form'
import { withConfig } from  '../../common/modules/config'
import { withValidation } from '../../common/modules/validation'
import { withProductData } from '../../common/modules/product-data'
import { withErrors } from '../../common/modules/errors'
import { withFields } from '../../common/modules/fields'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { toCurrency, asNumber } from '../../common/util'
import Description from '../../common/components/description'
import Errors from '../../common/components/errors'
import InputLabel from '../../common/components/input-label'
import FormGroup from '../../common/components/form-group'
import { mapValues, find } from 'lodash'


export const formConfig = state => {
    const fields = state.fields;
    const productData = state.productData
    const premierEnabled = fields.contentsSumInsured >= 50000;
    const coverageType = function(){
        if(fields.coverageType){
            return premierEnabled ? fields.coverageType : "BASIC"
        }
        return null
    }();

    return {
        rules: {
            contentsSumInsured:[
                Validation.enforce.required("Please enter a contents sum insured between $5,000 and $250,000."),
                Validation.enforce.number("Please enter a contents sum insured between $5,000 and $250,000."),
                Validation.enforce.rangeInclusive(5000, 250000, "Please enter a contents sum insured between $5,000 and $250,000."),
            ],
            contentsExcess:[],
            specifiedItemCover:[
                Validation.enforce.required("Please indicate if you would like to list any individual items above the unspecified item or high risk item limits."),
            ],
            specifiedItemData: [
                Validation.enforce.hasAtLeastOneEntry("Please add at least one high risk item.")
            ]
        },
        predicates:{
            specifiedItemData: fields.specifiedItemCover == true
        },
        options:{
            contentsExcess: productData.excesses.Contents.ALL_CLAIMS,
            specifiedItemCover: yesNoOptions
        },
        inferred:{
            coverageType, // In the form we check against the inferred coverageType instead of the fields.coverageType as we want to save what the user has selected for the field, but we may display a different value
            premierEnabled,
            // This should be pulled from the server. It currently does not come in any responses.
            namedPerilsHelp: `
                <h3>Named perils</h3>
                <ul>
                    <li>Fire</li>
                    <li>Explosion</li>
                    <li>Lightning or thunderbolt</li>
                    <li>Earthquake or tsunami</li>
                    <li>Theft</li>
                    <li>Vandalism and malicious damage</li>
                    <li>Water or liquid</li>
                    <li>Collision,</li>
                    <li>Falling tree, branch or aerial</li>
                    <li>Damage by animals (not own pets)</li>
                    <li>Riot</li>
                    <li>Storm, rain or flood</li>
                    <li>Glass breakag</li>
                </ul>
                Please see PDS for further detail on the cover provided
            `,
            // This should be pulled from the server. It currently does not come in any responses.
            contentsHelp: `
                <h3>Contents temporarily removed from the home unit</h3>
                <ul>
                    <li>Anywhere in Australia and New Zealand</li>
                    <li>Worldwide, but only for up to 90 consecutive days</li>
                    <li>Up to the high risk item limit for high risk items</li>
                    <li>Up to the sum insured listed for specified high risk items</li>
                    <li>Up to $2,500 per item and $10,000 in total for<ul>
                        <li>Jewellery, gold or silver articles, furs, watches or personal effects</li>
                        <li>Collections</li>
                        <li>Mobile phones, portable electronics</li>
                    </ul>
                </ul>
                `
        },
        transformOut: data => ({
            ...data,
            coverageType // Set the coverageType in the data sent to the inferred value, not nessessarily what the user has selected
        })
    }

}


@withSubmission
@withNavigation
@withValidation
@withProductData
@withErrors
@withFields
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    private showThreshold = 5000;


    constructor(props){
        super(props)
        this.state = {
            showRemainingForm:false
        }
    }

    onBasicPressed(e){
        this.props.actions.fields.updateField("coverageType", "BASIC")
    }


    onPremierPressed(e){
        this.props.actions.fields.updateField("coverageType", "PREMIER")
    }


    onContentsSumInsuredChanged(e){
        if(this.props.fields.coverageType == null && asNumber(e.target.value) >= this.showThreshold) this.props.actions.fields.updateField("coverageType", "BASIC")
        if(asNumber(e.target.value)){
            if(asNumber(e.target.value) >= this.showThreshold && !this.state.showRemainingForm){
                this.setState({
                    ...this.state,
                    showRemainingForm: true
                })
            }
        }

        this.props.actions.fields.updateField("contentsSumInsured", asNumber(e.target.value))
    }


    componentWillMount(){
        // For some reason the field coverageType is coverType after coming back from a restore
        if(this.props.fields.coverType && !this.props.fields.coverageType){
            this.props.fields.updateField("coverageType", this.props.fields.coverType)
        }
        
        this.setState({
            ...this.state,
            showRemainingForm: this.props.fields.contentsSumInsured >= this.showThreshold
        })

        // Set the contentsExcess to the standard value if it doesn't exist
        if(this.props.fields.contentsExcess == null){
            const option = find(this.props.fields.optionsExcessAmount, option => option.type == "STANDARD")
            this.props.actions.fields.updateField("contentsExcess", option ? option.amount : 500)
        }
    }


    render() {
        const fields = this.props.fields
        const form = this.props.form.getData()
        const coverageType:string = form.inferred.coverageType
        
        const items         = mapValues(this.props.productData.productLimits[coverageType], limit => limit.riskItem)
        const descriptions  = mapValues(this.props.productData.productLimits[coverageType], limit => limit.limitDesc)
        const helps         = mapValues(this.props.productData.productLimits[coverageType], limit => limit.helpText)
        
        const highRiskRow = (itemId:string) => (
            <Row>
                <Cell help={helps[itemId]}>{items[itemId]}</Cell>
                <Cell>{descriptions[itemId]}</Cell>
            </Row>
        )

        return (   
            <div className="row">
                <StepTitle>Tell us about your coverage</StepTitle>	
                <QuoteNumber />
                
                <StepBlock className="standard-input">
                    <FormGroup field="contentsSumInsured" errors={ this.props.errors.contentsSumInsured }>
                        <InputLabel field="contentsSumInsured" label="How much would you like to insure your contents for?" />    
                        <div className="row">
                        <div className="input-group col-sm-6">
                                <div className="input-group-addon"><i className="fa fa-usd" /></div>
                                <input
                                    id="contentsSumInsured"
                                    type="text"
                                    className="form-control"
                                    value={ toCurrency(this.props.fields.contentsSumInsured) }
                                    onChange={ this.onContentsSumInsuredChanged.bind(this) }
                                />
                            </div>
                        </div>
                        <Description description={<b><i className="fa fa-info-circle"></i> Please enter a contents sum insured between $5,000 and $250,000.</b>} />
                        
                        <Errors errors={ this.props.errors.contentsSumInsured } />
                    </FormGroup>
                </StepBlock>

                <div className={`w-100 ${ !this.state.showRemainingForm ? "hidden-xs-up" : "" }`}>
                    <StepBlock>
                        <InputLabel label="What cover option would you like?" />    
                        <button className="btn btn-primary btn-block btn-lg" onClick={ this.onBasicPressed.bind(this) }><i className={`fa ${coverageType == "BASIC" ? "fa-check-square-o animate-flash" : "fa-square-o"}`}></i> Basic</button>
                        <button className="btn btn-primary btn-block btn-lg" onClick={ this.onPremierPressed.bind(this) } disabled={ !form.inferred.premierEnabled }><i className={`fa ${coverageType == "PREMIER" ? "fa-check-square-o animate-flash" : "fa-square-o"}`}></i> Premier</button>
                        <Description description={<b><i className="fa fa-info-circle"></i> Premier cover only available on sums insured of at least $50,000.</b>} />
                    </StepBlock>

                    <StepBlock>
                        <Alert show={ fields.floodCover == "REQUIRED" } ><p>Flood cover is included with the policy</p></Alert>
                        <Alert show={ fields.floodCover == "NOT_INCLUDED" } ><p>This policy does not included flood cover</p></Alert>
                    </StepBlock>

                
                
                    <SubHeader>Your cover</SubHeader>
                    <Table split60x40 alternate>
                        <Row>
                            <Cell help={ form.inferred.namedPerilsHelp }>Named perils</Cell>
                            <Cell>{ fields.textNamedPerils }</Cell>
                        </Row>
                        <Row>
                            <Cell>Accidental damage</Cell>
                            <Cell>{coverageType == "BASIC" ? fields.textAccidentalDamageBasic : fields.textAccidentalDamagePremier}</Cell>
                        </Row>
                        <Row>
                            <Cell help={ form.inferred.contentsHelp }>Contents temporarily removed from the home unit</Cell>
                            <Cell>{coverageType == "BASIC" ? fields.textContentsTemporarilyRemovedFromHomeBasic : fields.textContentsTemporarilyRemovedFromHomePremier}</Cell>
                        </Row>
                        <Row>
                            <Cell>Legal Liability</Cell>
                            <Cell>{fields.textLegalLiability}</Cell>
                        </Row>
                    </Table>


                    <SubHeader>Excess</SubHeader>

                    <InputField field="contentsExcess" label="Excess amount" inline />

                    <Table split60x40 alternate>
                        <Row>
                            <Cell>Earthquake and tsunami</Cell>
                            <Cell>${toCurrency(fields.contentsExcess)}</Cell>
                        </Row>
                    </Table>


                    <SubHeader>High risk item limit</SubHeader>
                    <Table split60x40 alternate>
                        <Row asHeading>
                            <Cell>Items</Cell>
                            <Cell>Included limit</Cell>
                        </Row>
                        { highRiskRow("CASH") }
                        { highRiskRow("DOC") }
                        { highRiskRow("FIRE") }
                        { highRiskRow("CUR") }
                        { highRiskRow("JWL") }
                        { highRiskRow("WATCH") }
                        { highRiskRow("GOLD") }
                        { highRiskRow("PHOTO") }
                        { highRiskRow("BIC") }
                        { highRiskRow("PORT") }
                        { highRiskRow("ENT") }
                        { highRiskRow("MEDIA") }
                        { highRiskRow("MUSIC") }
                        { highRiskRow("ART") }
                        { highRiskRow("COLL") }
                        { highRiskRow("COMP") }
                        { highRiskRow("TOOL") }
                    </Table>


                    <SubHeader>Specified High Risk Items</SubHeader>
                    <InputField field="specifiedItemCover"                 label="Do you want to list any individual items above the high risk item limits?"  />
                    <HighRiskItemsEditor />

                    <Button.Container>
                        <Button.Back route="/step-3" />
                        <Button.Save onClick={ this.save.bind(this) } />
                        <Button.Continue onClick={ this.validate.bind(this) } />
                    </Button.Container>

                </div>
        
                
            </div>
        )
    }


    save(){
        this.props.actions.submission.save("/step-4", [
            formConfig
        ])
    }


    validate(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.step4
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            formConfig
        ] );
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-5")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/step-4.tsx